(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dv-bioavailability"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dvCounters) return; window.__dvCounters = true;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;
    const animate = (el) => {
      const target = parseInt(el.dataset.counter, 10) || 0;
      if (reduce) { el.textContent = target; return; }
      const start = performance.now();
      const dur = 1200;
      const tick = (now) => {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(target * eased);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if (!('IntersectionObserver' in window)) { counters.forEach(animate); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    counters.forEach((el) => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dvHeaderInit) return;
    window.__dvHeaderInit = true;

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---- sticky hide on scroll-down, restore on scroll-up
    const header = document.querySelector('.dv-h[data-sticky]');
    if (header && header.dataset.hideOnScroll !== 'false') {
      let lastY = window.scrollY;
      let ticking = false;
      const update = () => {
        const y = window.scrollY;
        header.classList.toggle('is-scrolled', y > 4);
        if (Math.abs(y - lastY) > 6 && y > 80) {
          header.classList.toggle('is-hidden', y > lastY);
        }
        if (y <= 80) header.classList.remove('is-hidden');
        lastY = y; ticking = false;
      };
      addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    }

    // ---- search overlay
    const srch = document.getElementById('dv-search');
    const srchInput = srch && srch.querySelector('[data-search-input]');
    const openSearch = () => { if (!srch) return; srch.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(() => srchInput && srchInput.focus(), 30); };
    const closeSearch = () => { if (!srch) return; srch.hidden = true; document.body.style.overflow = ''; };
    document.querySelectorAll('[data-search-open]').forEach(b => b.addEventListener('click', openSearch));
    document.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));

    // ---- mobile drawer
    const drw = document.getElementById('dv-drawer');
    const burger = document.querySelector('[data-drawer-open]');
    const setDrawer = (open) => {
      if (!drw) return;
      drw.setAttribute('aria-hidden', String(!open));
      burger && burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger && burger.addEventListener('click', () => setDrawer(true));
    document.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', () => setDrawer(false)));
    document.querySelectorAll('[data-search-open-mobile]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); setDrawer(false); openSearch(); }));

    // ---- ESC closes overlays
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { closeSearch(); setDrawer(false); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dvHeroInit) return;
    window.__dvHeroInit = true;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // fade-up on visibility
    const reveals = document.querySelectorAll('.dv-reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach((el) => io.observe(el));
    }

    // very subtle scroll-parallax on hero media
    if (!reduce) {
      const media = document.querySelector('.dv-hero__media[data-parallax]');
      if (media) {
        let ticking = false;
        const update = () => {
          const rect = media.getBoundingClientRect();
          const vh = window.innerHeight || 1;
          const progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - vh / 2) / vh));
          media.style.transform = `translate3d(0, ${progress * -12}px, 0)`;
          ticking = false;
        };
        window.addEventListener('scroll', () => {
          if (!ticking) { requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
        update();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
